import React, { useState, useEffect, useLayoutEffect, useCallback } from 'react';
import { View, FlatList, StyleSheet, SafeAreaView } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import useBoolean from '../utils/useBoolean';
import SearchFabMenuModal from '../components/SearchFabMenuModal';
// import FloatButton from '../components/FloatButton';
import TabBar from '../components/SegmentedControl/TabBar';
import NavigateFilter from '../components/NavigateFilter';
import BaseText from '../components/BaseText';
import { Modals } from '../constants/ScreenNames';
import { CommonStyles, CommonProperties, Color } from '../styles';
import {
  selectRailSort,
  selectRailBrandList,
  selectRailTimeMatrixFilterBy,
  selectFilteredRailList,
  selectRailBottomBar,
  selectedRailBrandFilter,
} from '../store/selectors/rail.selector';
import {
  railSetOrderBy,
  selectRail,
  getNextRailResults,
  filterRailResultsByBrand,
  filterTimeMatrixByType,
} from '../store/actions/rail';
import { selectFirstSearchCriteria } from '../store/selectors/search.selector';
import { RailCard } from '../components/resultCards';
import { movePrevious } from '../store/actions/workflow';
import { HeaderBackButton } from '@react-navigation/elements';
import HeaderTitle from '../components/shared/HeaderTitle';
import { rightFilterHeaderOption } from '../utils/defaultNavOptions';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import Interstitial from '../components/modals/Interstitial';
import useTextInterstitialOptions from '../utils/useTextInterstitialOptions';
import { searchTypesEnum } from '../constants/Enums';
import useTextOrderByRailList from '../utils/useTextOrderByRailList';
import CircleSegmentedControl from '../components/SegmentedControl/CircleSegmentedControl';
import {
  selectCompanyCurrencyCulture,
  selectCompanyCurrency,
} from '../store/selectors/auth.selector';
const RailScreen = ({ navigation, route }) => {
  const { t } = useTranslation(i18nNS.rail);
  const { tKey } = useComponentTKey('RailScreen');
  const routeParams = route.params;
  const dispatch = useDispatch();

  const [railLoading, setRailLoading] = useState(false);
  const selectedRailTimeMatrixFilterBy = useSelector(selectRailTimeMatrixFilterBy);
  const matrixBottomList = useSelector(selectRailBottomBar);
  matrixBottomList?.map((item) => {
    item.second = t(tKey(item.value));
    return item;
  });
  const railList = useSelector(selectFilteredRailList);
  const railSort = useSelector(selectRailSort);
  const filterBrand = useSelector(selectRailBrandList);
  const currentBrand = useSelector(selectedRailBrandFilter);
  const searchCriteria = useSelector(selectFirstSearchCriteria);
  const [modalVisible, showModal, hideModal] = useBoolean(false);
  const interstitialOptions = useTextInterstitialOptions(searchTypesEnum.RAIL);
  const [visibleNavigateFilter, showNavigateFilter, hideNavigateFilter] = useBoolean(false);
  const [orderByRailList] = useTextOrderByRailList();
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  const currency = useSelector(selectCompanyCurrency);
  const onSearchFabMenuModalPress = (value) => {
    switch (value) {
      case 0:
        navigation.navigate(Modals.RailFilterModal);
        break;
      case 1:
        navigation.navigate(Modals.ResearchWidgetModal);
        break;
    }
    hideModal();
  };

  const setSelectedFilter = useCallback((value) => dispatch(filterRailResultsByBrand(value)), [
    dispatch,
  ]);
  useLayoutEffect(() => {
    navigation.setOptions({
      headerLeft: (headerLeftProps) => (
        <HeaderBackButton {...headerLeftProps} onPress={() => dispatch(movePrevious())} />
      ),
      headerTitle: () => (
        <HeaderTitle
          title={(currentBrand && t(tKey(currentBrand))) || '...'}
          subtitle={
            routeParams.legNumber === 1
              ? t(tKey('Depart')) + moment(searchCriteria?.fromDate).format('MMM DD')
              : moment(searchCriteria?.toDate).format('MMM DD')
          }
          onPress={railList && railList.length > 0 && showNavigateFilter}
        />
      ),
      ...rightFilterHeaderOption(() => navigation.navigate(Modals.RailFilterModal)),
      headerTitleAlign: 'center',
    });
  }, [
    navigation,
    dispatch,
    currentBrand,
    routeParams.legNumber,
    filterBrand,
    showNavigateFilter,
    searchCriteria,
    t,
    tKey,
  ]);

  useEffect(() => {
    async function fetchRail() {
      setRailLoading(true);
      if (routeParams.legNumber === 2) {
        //leg2 api call
        await dispatch(getNextRailResults());
      }
      setRailLoading(false);
    }
    fetchRail();
  }, [dispatch, routeParams.legNumber]);

  return (
    <SafeAreaView style={styles.pageContainer}>
      <View style={styles.listContainer}>
        {railLoading ? (
          <Interstitial icon="rail" options={interstitialOptions} />
        ) : (
          <>
            <CircleSegmentedControl
              items={orderByRailList}
              onChange={(value) =>
                dispatch(railSetOrderBy(value, value === railSort.sort ? !railSort.asc : true))
              }
              selected={railSort?.sort}
            />
            <FlatList
              contentContainerStyle={styles.contentContainerStyle}
              data={railList}
              keyExtractor={(item) => item.Id}
              renderItem={({ item }) => (
                <RailCard
                  currentBrand={currentBrand}
                  showClassFares={true}
                  showPrice
                  style={CommonStyles.boxShadow}
                  item={item}
                  onPress={() => dispatch(selectRail(item, item.multiBrandFare[0]))}
                  currencyCulture={currencyCulture}
                  currency={currency}
                />
              )}
              ListEmptyComponent={() => (
                <BaseText style={styles.noResultsText}>{t(tKey('NoTrainsAvailable'))}</BaseText>
              )}
            />
          </>
        )}
      </View>
      {railList !== null && !railLoading && (
        <View>
          {/* <FloatButton onPress={() => showModal()} iconName="menu" /> */}
          <TabBar
            onChange={(value) => dispatch(filterTimeMatrixByType(value))}
            selected={selectedRailTimeMatrixFilterBy}
            items={matrixBottomList}
          />
        </View>
      )}

      <SearchFabMenuModal
        title={t(tKey('FilterRail'))}
        onPress={onSearchFabMenuModalPress}
        onClose={hideModal}
        visible={modalVisible}
      />

      <NavigateFilter
        onRequestClose={hideNavigateFilter}
        onPress={setSelectedFilter}
        selected={currentBrand}
        items={filterBrand?.map((item) => {
          return {
            ...item,
            name: t(tKey(item.key)),
          };
        })}
        visible={visibleNavigateFilter}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  listContainer: {
    flex: 2,
    ...CommonProperties.mt3,
  },
  contentContainerStyle: {
    flexGrow: 1,
  },
  pageContainer: {
    flex: 1,
    backgroundColor: Color.accent,
  },
  noResultsText: {
    textAlign: 'center',
    ...CommonProperties.mt3,
  },
});
export default RailScreen;
